/*jslint white: true, nomen: true, unparam : true, es5: true */
/*global document, window, Cookies, jQuery */
(function( $ ) {
    "use strict";

    $(document).ready(function($) {
        var $body = $('body');
        var $menuGroup = $('.menu-group');
        var $menuOther = $('.menu-other');      
        var lastScrollTop = 0;
    
        $(window).scroll(function() {
            var scrollTop = $(this).scrollTop();
             
            if (scrollTop > 150) {
                if (!$body.hasClass('scrolled')) {
                    $body.addClass('scrolled');                    
                }
               
            } else {
                if (scrollTop > 10){
                    $menuGroup.addClass('ts');
                    $menuOther.addClass('ts');                
                }
                else{
                    $menuGroup.removeClass('ts');
                    $menuOther.removeClass('ts');                
                    $body.removeClass('scrolled');
                    $menuGroup.css('top', '');
                    $menuOther.css('top', '');
                }
            }
            
            lastScrollTop = scrollTop;
        });
       
        $('.menu-group  nav.elementor-nav-menu--main > ul > li.menu-item-has-children').hover(function(){                 
               $('.menu-group > div > div').toggleClass('deplie');         
               $('#main-menu  nav.elementor-nav-menu--main > ul > li> ul').toggleClass('deplie');       
        });
        // aprc
        $('.menu-other  nav.elementor-nav-menu--main > ul > li.menu-item-has-children:nth-child(1)').hover(function(){                 
            $('.menu-other').toggleClass('aprc-sel');                     
        });
        // ksi
        $('.menu-other  nav.elementor-nav-menu--main > ul > li.menu-item-has-children:nth-child(2)').hover(function(){                 
            $('.menu-other').toggleClass('ksi-sel');                     
        });
        // supply chain
        $('.menu-other  nav.elementor-nav-menu--main > ul > li.menu-item-has-children:nth-child(3)').hover(function(){                 
            $('.menu-other').toggleClass('supply-sel');                     
        });
        
        // Energy
        $('.menu-other  nav.elementor-nav-menu--main > ul > li.menu-item-has-children:nth-child(4)').hover(function(){                 
            $('.menu-other').toggleClass('energy-sel');                     
        }); 
        // Natural solutions
        $('.menu-other  nav.elementor-nav-menu--main > ul > li.menu-item-has-children:nth-child(5)').hover(function(){                 
            $('.menu-other').toggleClass('natural-sel');                     
        });


        var hash = window.location.hash;
        if (hash) {            
            var target = $(hash);
            if (target.length) {                
                var targetOffset = target.offset().top - 350; // Ajustez la position
    
                // Défilement vers l'ancre lors du chargement de la page
                $('html, body').animate({
                    scrollTop: targetOffset
                }, 100); // Durée de l'animation en millisecondes
            }
        }
        // ancres plus basses
        $('a[href^="#"]').on('click', function(event) {          
            // Empêche le comportement par défaut du lien
            event.preventDefault();
            event.stopPropagation();
            
            var target = $(this).attr('href');            
            if ($(target).length) {
                var targetOffset = $(target).offset().top - 200;

                $('html, body').animate({
                    scrollTop: targetOffset
                }, 100); // Durée de l'animation en millisecondes
            }
        });
    });
    
    
}( jQuery ) );
